import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export interface OrderFileItem {
    idx: string;
    category: string;
    f_name: string;
    original_name: string;
    mime: string;
    file_path: string;
}

interface GetOrderFilesResponse {
    statusCode: number;
    message: string;
    data: OrderFileItem[];
}

export const useGetOrderFiles = (category: string): UseQueryResult<OrderFileItem[], Error> => {
    return useQuery<OrderFileItem[], Error>({
        queryKey: ["useGetOrderFiles", category],
        queryFn: async () => {
            const { data } = await axiosInstance.get<GetOrderFilesResponse>(
                `${enum_api_uri.order_file}/${category}`,
            );
            return data.data || [];
        },
        enabled: !!category,
    });
};
